import { ChangeDetectionStrategy, Component, contentChild, input, TemplateRef, viewChild } from '@angular/core';


@Component({
    selector: 'soft-drag-and-drop-select-item',
    imports: [],
    templateUrl: './drag-and-drop-select-item.component.html',
    styleUrl: './drag-and-drop-select-item.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DragAndDropSelectItemComponent<T> {
  value = input.required<T>();
  template = viewChild<TemplateRef<any>>('template');
}
